import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi) // Dil dosyalarını yüklemek için
  .use(LanguageDetector) // Tarayıcı dil algılayıcısı
  .use(initReactI18next) // React bağlayıcı
  .init({
    supportedLngs: ["en"], // Desteklenen diller
    fallbackLng: "en", // Varsayılan dil
    lng: "en",
    detection: {
      order: ["localStorage", "cookie", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"], // Seçimi kaydedeceği yerler
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Dil dosyalarının yolu
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
